module.exports = __webpack_public_path__ + "img/syncmanager_preview.81038efb.jpeg";